import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

import {
  getAccessToken, getLocalStorage, removeAccessToken, removeRefreshAccessToken
} from './storage';

import { LOCAL_STORAGE_CHATBOT } from 'utils/constants';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  ($config: AxiosRequestConfig): AxiosRequestConfig => {
    if ($config.headers) {
      const token = getAccessToken();
      const botKey = getLocalStorage(LOCAL_STORAGE_CHATBOT.BOTKEY);
      if (token) {
        $config.headers.Authorization = `Bearer ${token}`;
      }
      if (botKey) {
        $config.headers['X-Bot-Key'] = botKey;
      }
      $config.headers['Content-Type'] = 'application/json';
      $config.headers.Accept = 'application/json';
    }
    return $config;
  },
  async (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  async (error: AxiosError): Promise<AxiosError> => {
    if (error.response?.status === 401) {
      removeAccessToken();
      removeRefreshAccessToken();
      window.location.href = '/login';
    }
    return Promise.reject(
      error.response && error.response.status === 422 ? (error.response.data as any).errors : error,
    );
  },
);
export default axiosInstance;
